import { IStackedBarChart } from '../../../../models/Charts';
import { styleSheet } from './styles';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';

interface IProps<T extends object = any> {
	className?: string;
	chart: IStackedBarChart<T>;
	height?: number;
	onBarClick?(data: T): void;
	onRenderLoadingPlaceholder?(): React.ReactNode;
	styles?: StyleDeclarationValue[];
}

const LazyBarchart = React.lazy(() => import(/* webpackChunkName: "barchart" */ './barchart'));

export class StackedBarChart extends React.Component<IProps> {
	public render() {
		const { className, styles, chart, height, onBarClick, onRenderLoadingPlaceholder } = this.props;
		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} stacked-bar-chart ${className || ''}`}>
				<>
					<React.Suspense fallback={onRenderLoadingPlaceholder?.() || null}>
						<LazyBarchart chart={chart} height={height} onBarClick={onBarClick} />
					</React.Suspense>
				</>
			</div>
		);
	}
}
